module.exports = __webpack_public_path__ + "img/Redtrack.3598970d.png";